import ExternalAppStore from '../stores/ExternalApp/ExternalAppStore';

export default function windowTopZero(): number {
  if (window.externalAppConfig?.customTitleBar) {
    const titleBarHeight = ExternalAppStore.getCustomTitleBarHeight();
    return isNaN(titleBarHeight) ? 0 : titleBarHeight;
  }

  return 0;
}